



















import { Component, Vue } from 'vue-property-decorator';
import { INavItem } from '@/models/product-intro-index';

@Component({
  name: 'product-intro-index',
})
export default class ProductIntroIndex extends Vue {
  public navItems: INavItem[] = [{
    key: 'course',
    icon: require('@/assets/navcourse.jpg'),
    title: '课程系统',
    href: '#course-intro',
  }, {
    key: 'exam',
    icon: require('@/assets/navexam.jpg'),
    title: '考试系统',
    href: '#exam-intro',
  }, {
    key: 'oj',
    icon: require('@/assets/navoj.jpg'),
    title: 'MOJ',
    href: '#oj-intro',
  }];
}
